<template>
  <div class="cf-flex cf-flex--column cf-flex--gap-16 cf-flex-padding-y-16">
    <Teleport
      defer
      to="#portal-modal-header-target"
    >
      Unavailable Items
    </Teleport>

    <span class="cf-icon cf-icon--red cf-icon--large far fa-exclamation-circle" />

    <template v-if="unavailableItems.length === order.orderItems.length">
      <h4 class="cf-title cf-title--4">
        Oops! All of the items from your order are unavailable.
      </h4>

      <button
        type="button"
        class="cf-button cf-button--primary cf-button--lg cf-button--fill"
        @click="close"
      >
        Okay
      </button>
    </template>

    <template v-else>
      <h4 class="cf-title cf-title--4">
        Oops! The following {{ unavailableItems.length > 1 ? 'items are' : 'item is' }} unavailable:
      </h4>

      <ul class="cf-flex cf-flex--column cf-flex--align-start cf-flex--gap-12 cf-bullet-list">
        <li
          v-for="item in unavailableItems"
          :key="item.orderItemId"
          class="cf-flex cf-flex--column cf-flex--gap-10"
        >
          <h4 class="cf-title cf-title--4">
            {{ item.itemDescription }}
          </h4>

          <p
            v-if="item.unavailableModifiers && item.unavailableModifiers.length > 0"
            class="cf-subtitle cf-subtitle--2"
          >
            Unavailable {{ item.unavailableModifiers.length > 1 ? 'Modifiers' : 'Modifier' }}:
            <span>
              {{ item.unavailableModifiers.map(modifier => modifier.itemDescription).join(', ') }}
            </span>
          </p>
        </li>
      </ul>

      <p class="cf-subtitle cf-subtitle--2">
        Would you like to add the other item(s) to your cart?
      </p>

      <div class="cf-flex cf-flex--column cf-flex--gap-12">
        <button
          type="button"
          :class="['cf-button cf-button--primary cf-button--lg', { 'cf-button--loading': isReordering }]"
          @click="reorderWithUpdatedOrder(order)"
        >
          Add To Cart
        </button>

        <button
          type="button"
          class="cf-button cf-button--tertiary cf-button--lg cf-button--fill"
          @click="close"
        >
          Never Mind
        </button>
      </div>
    </template>
  </div>
</template>


<script>
  import errorHandlers from '@/services/error-handlers';

  import { getUnavailableItemsAndModifiers } from '@/helpers/unavailable-items';


  export default {
    name: 'ReorderItems',

    props: {
      order: {
        type: Object,
        required: true
      },

      unavailableItems: {
        type: Array,
        required: true
      }
    },

    data() {
      return {
        isReordering: false
      };
    },

    methods: {
      close() {
        this.$closeModal('reorder');
      },

      async reorderWithUpdatedOrder(order) {
        try {
          this.toggleLoading(true);

          const unavailableItemIds = getUnavailableItemsAndModifiers(order)
            .map(item => item.orderItemId);

          const updatedOrder = {
            ...order,
            orderItems: order.orderItems
              .filter(item => !unavailableItemIds.includes(item.orderItemId))
          };

          await this.$store.dispatch('orders/reorder', updatedOrder);
          this.$closeModal('reorder');
        }

        catch (error) {
          errorHandlers.generic(error);
        }

        finally {
          this.toggleLoading(false);
        }
      },

      toggleLoading(val) {
        this.isReordering = val;
      }
    }
  };
</script>
